/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Card Type
 * @export
 * @interface CardType
 */
export interface CardType {
    /**
     * Card type code
     * @type {string}
     * @memberof CardType
     */
    code?: string;
    /**
     * Card type name
     * @type {string}
     * @memberof CardType
     */
    name?: string;
}

/**
 * Check if a given object implements the CardType interface.
 */
export function instanceOfCardType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CardTypeFromJSON(json: any): CardType {
    return CardTypeFromJSONTyped(json, false);
}

export function CardTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CardTypeToJSON(value?: CardType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}

